import { useRef, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Container, Button, Row, Col, Modal, Card } from 'react-bootstrap'
import { useCuit } from 'pages/Alta/Hooks'
import { mainRequest } from 'utils/requests'

function GestionContribuyente() {
  const [showBaja, setShowBaja] = useState(false)
  const [altaFinalizada, setAltaFinalizada] = useState(false)

  const linkRef = useRef()
  const cuit = useCuit()
  const history = useHistory()

  useEffect(() => {
    let posible = true

    if (posible) {
      mainRequest('/ddjj/alta/api/finalizo').then(({ status, content }) => {
        if (content.success && posible) {
          setAltaFinalizada(content.finalizo)
        }
      })
    }

    return () => {
      posible = false
    }
  }, [])

  return (
    <Container fluid className="pb-5">
      <h5 className="text-muted text-normal text-uppercase">
        Gestión del contribuyente
      </h5>
      <hr className="p-3" />

      <h6 className="text-muted text-normal py-2">CUIT logueada: {cuit}</h6>

      <Row className="pt-5">
        <Col>
          <Button
            variant="primary"
            block
            onClick={() =>
              history.push('/ddjj/alta', { visualizarDatos: true })
            }
          >
            Visualizar datos
          </Button>
        </Col>
        <Col>
          <Button
            variant="warning"
            block
            onClick={() => history.push('/ddjj/alta', { modificarDatos: true })}
          >
            Modificar datos
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button variant="danger" block onClick={() => setShowBaja((s) => !s)}>
            Cese de actividades
          </Button>
        </Col>
        <Col>
          <a style={{ display: 'none' }} ref={linkRef} href="/#">
            #
          </a>
          <Button
            variant="link"
            block
            disabled={!altaFinalizada}
            onClick={() =>
              fetch('/ddjj/alta/api/comprobante')
                .then((res) => res.blob())
                .then((blob) => {
                  const href = window.URL.createObjectURL(blob)
                  const a = linkRef.current
                  a.download = `Comprobante de Alta - ${cuit}.pdf`
                  a.href = href
                  a.click()
                  a.href = ''
                })
                .catch((err) => console.log(err))
            }
          >
            Descargar comprobante
          </Button>
        </Col>
      </Row>
      <Modal
        show={showBaja}
        onHide={() => setShowBaja(false)}
        scrollable
        size="xl"
        style={{ zIndex: 9001 }}
        backdrop={true}
        centered={true}
      >
        <Modal.Body>
          <Card bg="danger" text="white" className="mb-5">
            <Card.Header className="d-flex justify-content-center align-items-center">
              <span className="material-icons" style={{ fontSize: '4rem' }}>
                delete_forever
              </span>
              <h3 className="text-white ml-4">Cese de actividades</h3>
            </Card.Header>
            <Card.Body className="py-3">
              <p className="lead">
                La opción que quiere realizar exige el libre deuda de la tasa,
                para mayor información contáctese con la Dirección de Ingresos
                Públicos mediante las siguientes vías, horarios y opciones de
                contacto.
              </p>
              <p className="lead">
                Para llamar por teléfono: de lunes a viernes, de 9 a 13 horas al
                0221 464 5569, 4645570 ó 4616486
              </p>
              <p className="lead">
                Para escribir por whatsapp: 221 464 5569, 4645570 ó 4643730.
              </p>
              <p className="lead">Correo electrónico: dip@berisso.gob.ar</p>
            </Card.Body>
          </Card>

          <Row className="d-flex justify-content-center">
            <Button variant="danger" onClick={() => setShowBaja(false)}>
              Cerrar
            </Button>
          </Row>
        </Modal.Body>
      </Modal>
    </Container>
  )
}

export default GestionContribuyente
